module.exports = __webpack_public_path__ + "static/media/samples.f366b655.png";